import { useEffect, useState } from 'react';
import { Button, Checkbox } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import AssetDragDrop from './AssetDragDrop';
import agent from '../../api/agent';
import { store, useStore } from '../../stores/store';
import { v4 as uuid } from 'uuid';
import sendRespectiveEmail from '../../models/EmailNew';
import { updateHistoryMain } from '../../models/history';
import './styles.css';
import { uploadFileType } from '../../api/types';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
//import { userLanguage } from "../userLanguageSchema/userLanguage";

interface Props {
  uploadURL: any;
  setOpen: any;
  name:string
}

const AssetFileUpload = ({ uploadURL, setOpen,name }: Props) => {
  const {
    viewStore: { viewPageHistoryAlone, getItemPageFilesStructure },
    activityStore,
    dashboardStore: { dashboard, getLocalFilesBasedOnItem },
    commonStore,
    userStore: { user },
    WorkLevelStore,
    ElementStore: { generatePdf },
  } = useStore();
  const [files, setFiles] = useState<File[]>([]);
  const [coverPhoto, setCoverPhoto] = useState<boolean>(false);
  const [previewPhoto, setPreviewPhoto] = useState<boolean>(false);

  const { selectedActivity: activity, uploadAssetCover } = activityStore;

  useEffect(() => {
    WorkLevelStore.loadWorkLevelBasedOnItemLevel(activity?.id);
    // eslint-disable-next-line
  }, [activity]);

  // useEffect(() => {
  //   if (activityRegistry.size <= 1) loadActivities();
  //   setSelectedItemLevel(activity)
  // },[activityRegistry.size, loadActivities, activity]);
  const onDrop = (acceptedFiles: File[]) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  };

  const HandleAvSync = (File:any[])=>{
    const bodies = File
    .filter((item: any) =>
      (item[0]?.toLowerCase()?.includes('reel') &&
      // eslint-disable-next-line
        item.length > 1 &&
        // eslint-disable-next-line 
        (item[2]?.includes(':') || item[1]?.includes(':')) || (item[0]?.toLowerCase()?.includes('REEL 02'))),
    )
    .map((item: any) => {
      const bodyObject: any = {};
      const headerValue = [
        'reel_No',
        'frame_Count',
        'start_Time_Code',
        'end_Time_Code',
        'audio_Scan_QC_Report',
        'audio_Scan_Report',
        'NFI_Digitization_QC_Report',
        'source_Remarks',
      ];
  
      if (item[0]?.toLowerCase()?.includes('reel 02') && !item[2]?.includes(':')) {
        const reel02Index = File.findIndex((fileItem: any) => fileItem[0]?.toLowerCase()?.includes('reel 02'));
        if (reel02Index !== -1) {
    const reelAndNextArray = File.slice(reel02Index, reel02Index + 2);      
          const newItem = [
            reelAndNextArray[0][0],
            '', // Add your logic for other fields
            '',
            '',
            reelAndNextArray[1][4],
            reelAndNextArray[1][5],
            reelAndNextArray[1][6],
          ];
  
          headerValue.forEach((header: any, index: number) => {
            bodyObject[header] = newItem[index] !== undefined ? newItem[index] : '';
          });
  
          return bodyObject;
        }
      }
  
      headerValue.forEach((header: any, index: number) => {
        bodyObject[header] = item[index] !== undefined ? item[index] : '';
      });
      return bodyObject;
    });
    if(bodies.length > 0){
      store.reportStore.AVSyncParrentDataHandle(activity?.id as string, bodies).then(() => {
        toast.success('File uploaded Successfully.');
      });
    }
    else{
      toast.error('File Upload Failed...')
    }
  }

  const upload = () => {
    files.forEach(async (file) => {
      if(name === 'Av Sync Upload'){
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target?.result;
          if (typeof data === 'string') {
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            HandleAvSync(excelData as any[]);
          }
        };
        reader.readAsBinaryString(file); 
      }
      // const fileSplit = file?.name?.split('.')[0];
      // let sampleFile = fileSplit.includes('(') ? fileSplit : fileSplit + ' (1)';
      // // let zerosplit = file?.name?.split('.')[0] + "(" + 1 + ")";
      // const toCheck = (name: string) => {
      //   if (fileNameArr?.includes(name)) {
      //     // if(!name[1]){
      //     // return zerosplit;
      //     // }else{
      //     let incVal = name?.match(/\(([^)]+)\)/)![1]; //"11"
      //     const toint = parseInt(incVal) + 1; //12
      //     incVal = toint?.toString(); //"12"
      //     sampleFile = sampleFile?.split('(')[0] + '(' + incVal + ')';
      //     toCheck(sampleFile);
      //     return sampleFile;
      //     // }
      //   }
      //   return sampleFile;
      // };

      sendRespectiveEmail('created', '', 'File Uploaded', '');
      const payload = {
        taskId: '',
        taskName: '',
        subTaskId: '',
        subTaskName: '',
        status: `added file ${
          user?.customerName === 'NFAIReport'
            ? 'NFAIReport_'.concat(file.name)
            : file.name
        } for`,
        date: new Date(),
      };
      updateHistoryMain(payload, false);
      let addFilesPayload: uploadFileType = { id: '', files: [] };
      if (commonStore.devEnv) {
        const item = activity?.id;
        const workLevel = dashboard.dashboardWorkLevelMaster?.id;
        let myNewFile: File = file;
        if (user?.customerName === 'NFAIReport') {
          myNewFile = new File([file], 'NFAIReport_'.concat(file.name), {
            type: file.type,
          });
        }
        const response = await agent.Files.localFileUpload(
          user?.customerName === 'NFAIReport' ? myNewFile : file,
          workLevel,
          item,
        );
        const url = response?.data.path.replace(/\\\\/g, '\\');
        const filename = url.substring(url.lastIndexOf('\\') + 1);
        const alteredResponse = {
          id: response.data.id,
          url: url,
          fileName: filename,
        };
        uploadURL(alteredResponse);
        getLocalFilesBasedOnItem(item).then(async ()=>{
        if(name === 'NFHM Picture QC Upload' && commonStore.NFAIReportCustomer){
        await agent.NFAI.extractPdfInfo(activity?.id || '', url || '')
      }
        });
        if (coverPhoto || previewPhoto) {
          await uploadAssetCover(
            item,
            coverPhoto ? response.data.path : '',
            previewPhoto ? response.data.path : '',
          );
        }
        addFilesPayload = {
          id: activity?.id,
          files: [
            {
              id: uuid(),
              fileId: response.data.id,
              fileName: filename,
              url: url,
              addedOn: new Date(),
            },
          ],
        };
      } else {
        // let myNewFile: File = file;
        // if(user?.customerName === 'NFAIReport') {
        //   myNewFile = new File([file], 'NFAIReport_'.concat(file.name), {type: file.type});
        // }
        // const response = await agent.Files.uploadFile(user?.customerName === 'NFAIReport' ? myNewFile : file);
        const response = await agent.Files.uploadFile(file);
        uploadURL(response.data);
        if (coverPhoto || previewPhoto) {
          await uploadAssetCover(
            activity?.id,
            coverPhoto ? response.data.url : '',
            previewPhoto ? response.data.url : '',
          );
        }
        addFilesPayload = {
          id: activity?.id,
          files: [{ ...response.data, addedOn: new Date() }],
        };
      }
      await generatePdf(addFilesPayload);
      setFiles([]);
      setOpen(false);
    });
    setTimeout(() => {
      viewPageHistoryAlone({
        itemId: activity?.id,
        pageNo: 1,
        pageSize: 4,
      });
      getItemPageFilesStructure({
        itemId: activity?.id,
      });
    }, 200);
  };

  return (
    <div style={{ width: '100%' }}>
      <AssetDragDrop files={files} onDrop={onDrop} name={name}/>
      <Button
        onClick={upload}
        positive
        //Upload
        // {(userLanguage[0].Level3InventoryRecievingVerify?.IRVB04 as any)?.[`${commonStore.language.key}`]}
      >
        Upload
      </Button>
      {name !== 'Av Sync Upload' && name !== 'NFHM Picture QC Upload' ? <div className="customize-upload">
        <Checkbox
          label="Use as cover photo"
          onChange={() => setCoverPhoto(!coverPhoto)}
        />
        <Checkbox
          label="Use as preview for item"
          onChange={() => setPreviewPhoto(!previewPhoto)}
        />
      </div> : null}
    </div>
  );
};

export default observer(AssetFileUpload);
